import { useState, useEffect, useCallback } from 'react';
import { useLazyCreateCart } from 'src/services/MagentoClient';
import { SubscriptionStateResponse } from 'src/types/subscription';
import { PrinterItem } from 'src/utils/Products/productFilter';
import {
  AddProductsToUpgradeCartResponse,
  UpgradeCart
} from 'src/types/graphql/product';

interface useCreateClientProps {
  subscriptions?: SubscriptionStateResponse[];
  selectedPrinterDetails?: PrinterItem;
}
export const useCreateCart = ({
  subscriptions,
  selectedPrinterDetails
}: useCreateClientProps) => {
  const [cartInfo, setCartInfo] = useState<UpgradeCart>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [createCartDetails] = useLazyCreateCart();

  const selectedPlanDetails = selectedPrinterDetails?.inkPlan.find(
    (plan) => plan.recommendedPlan === true
  );
  const printerSKU = selectedPrinterDetails?.productSKU || '';
  const printerUID = selectedPrinterDetails?.printerUID || '';
  const selectedInkPlanUID = selectedPlanDetails?.inkUID || '';
  const selectedLeasePlanUID = selectedPlanDetails?.leaseUID || '';
  const selectedPaperPlanUID = selectedPlanDetails?.paperUID || '';
  const selectedcarepackUID = selectedPlanDetails?.carepackUID || '';

  const createCart = useCallback(async () => {
    setIsLoading(true);
    await createCartDetails({
      variables: {
        hp_subscription_id: subscriptions?.[0]?.subscriptionId,
        printer_sku: printerSKU,
        selected_printer_uid: printerUID,
        selected_ink_plan_uid: selectedInkPlanUID,
        selected_lease_plan_uid: selectedLeasePlanUID,
        selected_carepack_uid: selectedcarepackUID,
        selected_paper_plan_uid: selectedPaperPlanUID
      },
      onError: (error: unknown) => {
        console.log('Cart creation error:', error);
        setError(true);
        setIsLoading(false);
      },
      onCompleted: (response: AddProductsToUpgradeCartResponse) => {
        setCartInfo(response?.addProductsToUpgradeCart?.cart || null);
        setError(false);
        setIsLoading(false);
      }
    });
  }, [
    createCartDetails,
    subscriptions,
    selectedPrinterDetails,
    selectedPlanDetails
  ]);

  useEffect(() => {
    if (selectedPrinterDetails && subscriptions?.[0]) {
      createCart();
    }
  }, []);

  return { isLoading, error, cartInfo, createCart, setError };
};
